/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Servis_S4_Li_Maintenance_TextInputs */

const tr_servis_s4_li_maintenance_text = /** @type {(inputs: Servis_S4_Li_Maintenance_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` en az 72 saat önceden duyurulur, mümkün olduğunca düşük kullanım saatlerinde yapılır`)
};

const en_servis_s4_li_maintenance_text = /** @type {(inputs: Servis_S4_Li_Maintenance_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` announced at least 72 hours in advance, carried out during low usage hours where possible`)
};

const de_servis_s4_li_maintenance_text = /** @type {(inputs: Servis_S4_Li_Maintenance_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` wird mindestens 72 Stunden im Voraus angekündigt und nach Möglichkeit in Zeiten geringer Nutzung durchgeführt`)
};

const ru_servis_s4_li_maintenance_text = /** @type {(inputs: Servis_S4_Li_Maintenance_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` объявляются не менее чем за 72 часа и по возможности проводятся в часы низкой нагрузки`)
};

/**
* | output |
* | --- |
* | "announced at least 72 hours in advance, carried out during low usage hours where possible" |
*
* @param {Servis_S4_Li_Maintenance_TextInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const servis_s4_li_maintenance_text = /** @type {((inputs?: Servis_S4_Li_Maintenance_TextInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Servis_S4_Li_Maintenance_TextInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_servis_s4_li_maintenance_text(inputs)
	if (locale === "de") return de_servis_s4_li_maintenance_text(inputs)
	if (locale === "ru") return ru_servis_s4_li_maintenance_text(inputs)
	return tr_servis_s4_li_maintenance_text(inputs)
});